import { render, staticRenderFns } from "./ChargeForm.vue?vue&type=template&id=38225019"
import script from "./ChargeForm.vue?vue&type=script&lang=js"
export * from "./ChargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports